import { Component, OnInit } from '@angular/core';
import { Utils } from "src/app/common/utils";
import { Router } from "@angular/router";
import { utils } from 'protractor';
import { SocketsConnectionService } from 'src/app/service/websockets/connection.service';

@Component({
  selector: 'app-header-new',
  templateUrl: './header-new.component.html',
  styleUrls: ['./header-new.component.css']
})
export class HeaderNewComponent implements OnInit {

  public patientRoutes: boolean = false;
  homePageUrl = Utils.homePageUrl;
  whoWeUrl = Utils.whoWeUrl;
  ourTeamUrl = Utils.ourTeamUrl;
  faqUrl = Utils.faqUrl;
  contactUsUrl = Utils.contactUsUrl;
  blogUrl = Utils.blogUrl;

  constructor(private utils: Utils, private router: Router, private socketsConnectionService: SocketsConnectionService) { }

  ngOnInit() {
    if (localStorage.getItem("LogUsrTyp")) this.patientRoutes = this.utils.checkRoutesAccess(JSON.parse(localStorage.getItem("LogUsrTyp")), [4]);
  }

  logout() {
    if (JSON.parse(localStorage.getItem("remember"))) {
      let u_name = localStorage.getItem("username");
      let pwd = localStorage.getItem("password");
      let rem = localStorage.getItem("remember");
      localStorage.clear();
      localStorage.setItem("username", u_name);
      localStorage.setItem("password", pwd);
      localStorage.setItem("remember", rem);
    }
    else
      localStorage.clear();
    this.socketsConnectionService.disconnect()
    this.router.navigate(["/login"]);
  }

}
